import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import MuiButton from "./Button";

const Button = styled(MuiButton)`
  font-weight: 500;
`;

const CancelButton = props => {
  const { onClick, text } = props;
  return (
    <Button onClick={onClick} textColor="#00303B" {...props}>
      {text}
    </Button>
  );
};

CancelButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired
};

export default CancelButton;
